import { Component, Inject, OnInit } from '@angular/core';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { ConfirmationPopupComponent } from '../confirmation-popup/confirmation-popup.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { Config } from 'src/app/app-constant';
import { jsPDF } from "jspdf";
import html2canvas from 'html2canvas';

@Component({
  selector: 'app-home-create-announcement-popup',
  templateUrl: './home-create-announcement-popup.component.html',
  styleUrls: ['./home-create-announcement-popup.component.scss'],
})
export class HomeCreateAnnouncementPopupComponent  implements OnInit {
  loggedInUserCompanyID:any;
  buttonColorName:any;
  loggedInUserRole:any;
  AnnouncementName:any;
  AnnouncementSubject:any;
  AnnouncementId:any;
  AnnouncementDescription:any; 
  isInvalidAnnouncementName:boolean = false;
  isInvalidAnnouncementSubject:boolean = false
  isInvalidAnnouncementDescription:boolean = false;
  
  constructor(public dialog: MatDialog, public dialogRef: MatDialogRef<HomeCreateAnnouncementPopupComponent>,
    private encryptionService: EncryptionService, private httpService: HttpService,   private config: Config,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.AnnouncementName = this.data?.name;
    this.AnnouncementSubject = this.data?.subject;
    this.AnnouncementDescription = this.data?.body;
    this.AnnouncementId = this.data.id

    console.log("Announcement",this.data);
    
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
  }

  editorConfig: AngularEditorConfig = { 
    editable: true,
      spellcheck: true,
      height: '350px',
      minHeight: '0',
      maxHeight: 'auto',
      width: 'auto',
      minWidth: '0',
      translate: 'yes',
      enableToolbar: true,
      showToolbar: true,
      placeholder: 'Enter Announcement Here...',
      defaultParagraphSeparator: '',
  }

  stripHtmlTags(content: string): string {
    const div = document.createElement('div');
    div.innerHTML = content;
    return div.innerText;
  }

  isInvalidAnnouncement(){
    this.isInvalidAnnouncementName = !this.AnnouncementName?.trim();
    this.isInvalidAnnouncementSubject = !this.AnnouncementSubject?.trim();
    this.isInvalidAnnouncementDescription = !this.AnnouncementDescription?.trim();
  }

  onClickSaveAnnouncement(){
    this.isInvalidAnnouncement();
    if(!this.isInvalidAnnouncementName && !this.isInvalidAnnouncementSubject && !this.isInvalidAnnouncementDescription){
      this.isInvalidAnnouncementName = false;
      this.isInvalidAnnouncementSubject = false;
      this.isInvalidAnnouncementDescription = false;
      const LetterTextContent = this.stripHtmlTags(this.AnnouncementDescription);
      const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
        disableClose: true,
        height: '25%',
        width: window.innerWidth <= 500 ? '90%' : window.innerWidth <= 800 ? '50%' : '30%',
        data: {
          msg: 'Announcement successfully Added',
          btn1: 'Cancel',
          btn2: 'Yes',
          btn2BgColor: this.buttonColorName,
          showSuccessIcon: true,
          showSuccessMessage: false,
          showCloseIcon: false
        },
      });
      dialogRef.afterClosed().subscribe((result:any) => {
        if (result) { 
          const request = {
            "body": this.AnnouncementDescription,
            "companyId": this.loggedInUserCompanyID,
            "id": this.AnnouncementId || null,
            "name": this.AnnouncementName,
            "subject": this.AnnouncementSubject
          }
          this.httpService.callPostService(this.config.setAnnouncement, request).subscribe((result:any)=>{
            if(result){
              this.dialogRef.close(); 
            }
          })
        }
      });      
    }
  }

  

  onClickDownlaodAnnouncement(elementId: string): void {
    const element = document.getElementById(elementId);

    if (!element) {
      console.warn('Element not found:', elementId);
      return;
    }
    element.classList.add('getAnnouncementPdf');
    setTimeout(() => {
      html2canvas(element, {
        scale: 2,
        useCORS: true,
        allowTaint: true,
        logging: false,
        backgroundColor: null,
        windowWidth: document.body.scrollWidth,
        scrollY: -window.scrollY,
      }).then(canvas => {
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF('p', 'mm', 'a4');
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();
  
        const imgWidth = pdfWidth;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;
  
        let heightLeft = imgHeight;
        let position = 0;
  
        pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pdfHeight;
  
        while (heightLeft > 0) {
          position = heightLeft - imgHeight;
          pdf.addPage();
          pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
          heightLeft -= pdfHeight;
        }

        pdf.save('announcement.pdf');
        element.classList.remove('getAnnouncementPdf');
      });
    }, 200); 
  }



  // onClickDownlaodAnnouncement(chartId: any): void {
  //   const chartElement: any = document.getElementById(chartId);
  //   const scaleFactor = 1;
  //   html2canvas(chartElement, { scale: scaleFactor }).then(canvas => {
  //     const imgData = canvas.toDataURL('image/png');
  //     const pdf = new jsPDF();
  //     const currentDate = new Date();
  //     const todayDate = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1)
  //       .toString()
  //       .padStart(2, '0')}-${currentDate.getDate().toString().padStart(2, '0')}`;

  //     const imgWidth = 190;
  //     const imgHeight = (canvas.height * imgWidth) / canvas.width;
  //     pdf.addImage(imgData, 'PNG', 10, 45, imgWidth, imgHeight);
  //     pdf.save(`${'abc'}-${todayDate}.pdf`);
  //   });
  // }
}
